import { ReactNode } from "react";
import { DayOfWeek, DayPicker, DayPickerProps } from "react-day-picker";
import { fr } from "react-day-picker/locale";

import { Days } from "../../types/enums/Days";
import Text from "../Text";
import styles from "./styles.module.scss";

type CalendarProps = {
    className?: string;
    header?: ReactNode;
    dayPickerProps: DayPickerProps;
};

function Weekday({ ...props }) {
    if (Days.Sunday === props.children) {
        return <></>;
    }

    if (Days.Saturday === props.children) {
        return <th {...props} style={{ visibility: "hidden" }}></th>;
    }

    return (
        <th {...props}>
            <Text variant="body-bold">{props.children}</Text>
        </th>
    );
}

const Calendar = ({ className, header, dayPickerProps }: CalendarProps) => {
    const daysStrings = ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"];
    const reformmat = {
        ...fr,
        localize: {
            ...fr.localize,
            day: (values: any) => {
                return daysStrings[values];
            },
        },
    };

    const weekend: DayOfWeek = { dayOfWeek: [0, 6] };
    const weekday: DayOfWeek = { dayOfWeek: [1, 2, 3, 4, 5] };

    return (
        <div className={`${styles.calendarContainer} ${className || ""}`}>
            {header}
            <DayPicker
                {...dayPickerProps}
                locale={dayPickerProps.locale ?? reformmat}
                modifiers={dayPickerProps.modifiers ?? { weekend, weekday }}
                components={{
                    Weekday,
                    ...(dayPickerProps.components || {}),
                }}
            />
        </div>
    );
};

export default Calendar;
